module.exports = __webpack_public_path__ + "img/facts-all_1935.a0e2cfa4.png";